export const ConfOpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@confOpinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@confOpinometro/API_RESPONSE_ERROR',

  GET_CONF_OPINOMETRO: '@@confOpinometro/GET_CONF_OPINOMETRO',
  UPDATE_CONF_OPINOMETRO: '@@confOpinometro/UPDATE_CONF_OPINOMETRO',

  RESET: '@@confOpinometro/RESET'
}
